import { useSyncExternalStore } from "react";

const KEY = "a11y-text-size";
export const TEXT_SIZES = [
  { id: "standard", label: "Standard", scale: "100%" },
  { id: "large", label: "Large", scale: "125%" },
  { id: "xlarge", label: "Extra Large", scale: "150%" },
];
const valid = (value) => TEXT_SIZES.some((size) => size.id === value);
const read = () => { try { const value = localStorage.getItem(KEY); return valid(value) ? value : "standard"; } catch { return "standard"; } };
let size = read();
const listeners = new Set();
const apply = (value) => {
  if (value !== size) window.dispatchEvent(new CustomEvent("theotokos:before-text-size"));
  size = value;
  document.documentElement.dataset.textSize = value;
  ["standard", "large", "xlarge"].forEach((id) => document.documentElement.classList.toggle(`a11y-${id}`, id === value));
  listeners.forEach((notify) => notify());
};
apply(size);
window.addEventListener("storage", (event) => { if (event.key === KEY || event.key === null) apply(read()); });
const subscribe = (notify) => { listeners.add(notify); return () => listeners.delete(notify); };
export const setTextSize = (value) => {
  if (!valid(value)) return;
  try { localStorage.setItem(KEY, value); } catch { /* Still works for this visit when storage is unavailable. */ }
  apply(value);
};
export const useTextSize = () => useSyncExternalStore(subscribe, () => size);